webpackJsonp([263736687359637],{

/***/ 1532:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"ProviderPunchInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"clockIn","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"clockOut","type":{"kind":"SCALAR","name":"DateTime","ofType":null}},{"defaultValue":null,"description":null,"name":"providerId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-provider-punch-input-6dfd13352c4eba8065c7.js